import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { toggleSelections as toggleSelectionAction } from '../state/reducers/ticket/ticket';

import { useReduxActions } from './use-redux-actions';

export function useToggleSelections() {
  const { locale } = useIntl();

  const toggleSelectionsAction = useReduxActions(toggleSelectionAction);

  return useCallback(
    payload => {
      toggleSelectionsAction({ locale, ...payload });
    },
    [locale, toggleSelectionsAction]
  );
}
